import React, { useCallback, useState } from 'react';
import webCore from '@happylife-a/web-core';
import webApp from '@happylife-a/web-app';
import { Flex, Spinner } from '@chakra-ui/react';

export default function AddToCartButton({ productDetail }) {
  const { t } = webCore.contexts.useTranslation();
  const { isInCart, toggleCart, refetchCarts } = webCore.contexts.useShoppingCarts();

  const toast = webApp.theme.hooks.useToast();
  const [loadingProductId, setLoadingProductId] = useState(null);

  const onCartToggle = useCallback(
    (detailId) => {
      setLoadingProductId(detailId);

      toggleCart(detailId, {
        count: 1,
        onCreate: () => {
          toast({ status: 'success', title: t('Added to cart') });
          refetchCarts();
          setLoadingProductId(null);
        },
        onDelete: () => {
          toast({ status: 'success', title: t('Removed from cart') });
          refetchCarts();
          setLoadingProductId(null);
        },
      });
    },
    [toggleCart, refetchCarts, toast, t]
  );

  const isLoadingThis = loadingProductId === productDetail?.id;

  return (
    <Flex cursor="pointer" onClick={() => onCartToggle(productDetail?.id)}>
      {isLoadingThis ? (
        <Spinner size="sm" />
      ) : isInCart(productDetail?.id) ? (
        <webApp.theme.icons.ShoppingCartActiveIcon
          w={5}
          h={5}
          stroke="primary.500"
          fill="primary.500"
        />
      ) : (
        <webApp.theme.icons.ShoppingCartIcon w={5} h={5} stroke="primary.500" fill="white" />
      )}
    </Flex>
  );
}
